import { Helmet } from "react-helmet-async";
import SonTweetler from "../bilesenler/SonTweetler"; // Yeni bileşeni import ediyoruz

// Sabitleri dosyanın en üstüne taşıdık
const USERNAME = "hacialikara";
const PROFILE_PIC = "./resimler/profil.png";

// !! ÖNEMLİ !!
// BURADAKİ URL'Yİ KENDİ FIREBASE FONKSİYONUNUZUN URL'Sİ İLE DEĞİŞTİRİN
const TWEET_API_URL = "https://us-central1-hacialikara.cloudfunctions.net/api/tweets";

const Hakkimda = () => {
  return (
    <div className="hakkimda-page rounded-3">
      {/* SEO Başlık ve Meta Tagları */}
      <Helmet>
        <title>Hakkımda - Hacı Ali Kara | Web Tasarım & Eğitim</title>
        <meta
          name="description"
          content="Hacı Ali Kara'nın kişisel portfolyo sitesi. Web tasarım, web geliştirme ve İngilizce eğitimi alanlarında 8+ yıllık deneyimi keşfedin."
        />
        <meta
          name="keywords"
          content="Hacı Ali Kara, web tasarım, web geliştirme, İngilizce öğretmeni, portfolyo, Kocaeli, eğitim, React, JavaScript"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Hakkımda - Hacı Ali Kara | Web Tasarım & Eğitim" />
        <meta
          property="og:description"
          content="Hacı Ali Kara'nın web tasarım, geliştirme ve İngilizce eğitimi deneyimlerini keşfedin. Modern ve kullanıcı dostu web siteleri tasarlıyorum."
        />
        <meta property="og:image" content="https://www.hacialikara.com/resimler/logohaciali.png" />
        <meta property="og:url" content="https://www.hacialikara.com/hakkimda" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.hacialikara.com/hakkimda" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Person",
              "name": "Hacı Ali Kara",
              "jobTitle": "Web Tasarımcı ve İngilizce Öğretmeni",
              "url": "https://www.hacialikara.com/hakkimda",
              "image": "https://www.hacialikara.com/resimler/logohaciali.png",
              "description": "Hacı Ali Kara, web tasarım, web geliştirme ve İngilizce eğitimi alanlarında 8+ yıllık deneyime sahip bir profesyonel.",
              "sameAs": [
                "https://twitter.com/${USERNAME}",
                "https://www.linkedin.com/in/hacialikara"
              ]
            }
          `}
        </script>
      </Helmet>

      {/* Kahraman Bölümü */}
      <section id="hero" className="hero section">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row align-items-center content">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <h1>Kişisel Portfolyom</h1>
              <p className="lead">
                Bu web sitesi, çalışmalarımı ve projelerimi bir araya getirdiğim bir depo olarak tasarlandı. Burada, fikirlerimi ve emeklerimi düzenli bir şekilde saklıyor, aynı zamanda sizlerle paylaşarak bir arşiv oluşturuyorum. Her bir proje, kendi sürecini ve hikayesini yansıtıyor. Amacım, yaptığım işleri sade ve anlaşılır bir şekilde sunmak; belki bir fikir, belki bir detay size ilham verir. Keşfetmek isterseniz, her bölümde yeni bir çalışma sizleri bekliyor. Hoş geldiniz!
              </p>
              <div className="cta-buttons" data-aos="fade-up" data-aos-delay="300">
                <a href="/portfolyom" className="btn btn-primary">
                  Çalışmalarımı Görüntüle
                </a>
                <a href="/iletisim" className="btn btn-outline">
                  Bağlantı Kuralım
                </a>
              </div>
              <div className="hero-stats" data-aos="fade-up" data-aos-delay="400">
                <div className="stat-item">
                  <span className="stat-number">8+</span>
                  <span className="stat-label">Yıllık Deneyim</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">30+</span>
                  <span className="stat-label">Tamamlanan Projeler</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">25+</span>
                  <span className="stat-label">Mutlu Müşteriler</span>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero-image">
                <img
                  src="resimler/logohaciali.png"
                  alt="Hacı Ali Kara Portfolyo Görseli"
                  className="img-fluid"
                  data-aos="zoom-out"
                  data-aos-delay="300"
                  loading="lazy"
                />
                <div className="shape-1"></div>
                <div className="shape-2"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hakkımda Bilgileri */}
      <div className="container my-5">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card h-100 shadow-lg border-0 hover-effect">
              <div className="card-body p-4">
                <h2 className="card-title mb-3">Hakkımda</h2>
                <p className="card-text">
                  Kocaeli Üniversitesi İngiliz Dili ve Edebiyatı bölümünden mezunum. Sekiz yılı aşkın süredir eğitim alanında çalışıyorum ve şu anda Özel Kocaeli Güneş Okulları'nda İngilizce öğretmeni olarak görev yapıyorum. Ayrıca İngilizce Zümre Başkanı olarak sorumluluk üstleniyorum.
                </p>
                <p className="card-text">
                  Bunun yanı sıra, web tasarım ve geliştirme üzerine projeler üretiyorum. HTML, CSS, JavaScript ve React gibi araçları kullanarak sade ve kullanıcı odaklı web siteleri oluşturmaya özen gösteriyorum.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card h-100 shadow-lg border-0 hover-effect">
              <div className="card-body p-4">
                <h2 className="card-title mb-3">About Me</h2>
                <p className="card-text">
                  I graduated from Kocaeli University with a degree in English Language and Literature. For over eight years, I have been working in education, currently serving as an English teacher at Özel Kocaeli Güneş Schools, where I also take on the role of English Department Coordinator.
                </p>
                <p className="card-text">
                  In addition, I work on web design and development projects. Using tools like HTML, CSS, JavaScript, and React, I focus on creating simple and user-friendly websites.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Yaptıklarım Bölümü */}
      <div className="container mt-5">
        <div className="row g-4">
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-lg border-0 hover-effect text-center p-4">
              <i className="bi bi-book fs-1 text-primary mb-3"></i>
              <h3>İngilizce Öğretmenliği</h3>
              <p>Ortaokul öğrencilerine etkili ve ilgi çekici yöntemlerle İngilizce öğretiyorum.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-lg border-0 hover-effect text-center p-4">
              <i className="bi bi-person fs-1 text-success mb-3"></i>
              <h3>Özel İngilizce Dersleri</h3>
              <p>Bireysel ihtiyaçlara uygun kişiselleştirilmiş bire bir İngilizce dersleri sunuyorum.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-lg border-0 hover-effect text-center p-4">
              <i className="bi bi-laptop fs-1 text-warning mb-3"></i>
              <h3>Web Tasarım</h3>
              <p>Modern, kullanıcı dostu ve yüksek kaliteli web site tasarımları oluşturuyorum.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-lg border-0 hover-effect text-center p-4">
              <i className="bi bi-code-slash fs-1 text-danger mb-3"></i>
              <h3>Web Geliştirme</h3>
              <p>Çeşitli ihtiyaçlar için tam işlevsel ve profesyonel web siteleri geliştiriyorum.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Yapay Zeka Bölümü */}
      <section id="hero-ai" className="hero section">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row align-items-center content">
            <div className="col-lg-6">
              <div className="hero-image">
                <img
                  src="resimler/hacialirobot.png"
                  alt="Hacı Ali Kara Yapay Zeka Görseli"
                  className="img-fluid"
                  data-aos="zoom-out"
                  data-aos-delay="300"
                  loading="lazy"
                />
                <div className="shape-1"></div>
                <div className="shape-2"></div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <h1>Yapay Zeka</h1>
              <p className="lead">
                "Zeka, artık bir sınırla değil, büyük bir okyanus gibi genişleyecek; her dalga, insanın hayal gücünden, her kıyı, yapay zekanın sunduğu büyük olasılıklardan beslenerek bir araya gelecek. Bu dünya, bir arada olmanın gücüyle büyüyecek, insan ve makine el birliğiyle hayatı daha parlak, daha anlamlı, daha derin kılacak."
              </p>
              <div className="cta-buttons" data-aos="fade-up" data-aos-delay="300">
                <a href="/portfolyom" className="btn btn-primary">
                  Çalışmalarımı Görüntüle
                </a>
                <a href="/iletisim" className="btn btn-outline">
                  Bağlantı Kuralım
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Web Tasarım Becerileri Bölümü */}
      <div className="container my-5">
        <h2 className="text-center mb-5">Web Tasarım ve Geliştirme Becerilerim</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card h-100 shadow-lg border-0 hover-effect text-center p-4">
              <i className="bi bi-file-code fs-1 text-primary mb-3"></i>
              <h3>HTML & CSS</h3>
              <p>Semantik HTML5 ve modern CSS3 ile responsive, erişilebilir web arayüzleri tasarlıyorum.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100 shadow-lg border-0 hover-effect text-center p-4">
              <i className="bi bi-code-square fs-1 text-warning mb-3"></i>
              <h3>JavaScript & React</h3>
              <p>Interaktif ve dinamik web uygulamaları geliştirmek için JavaScript ve React kullanıyorum.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100 shadow-lg border-0 hover-effect text-center p-4">
              <i className="bi bi-bootstrap fs-1 text-danger mb-3"></i>
              <h3>Bootstrap & Tailwind</h3>
              <p>Hızlı ve estetik tasarımlar için Bootstrap ve Tailwind CSS ile çalışıyorum.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tweetler Bölümü (Yeni Bileşenle) */}
      <SonTweetler
        apiEndpoint={TWEET_API_URL}
        username={USERNAME}
        profilePic={PROFILE_PIC}
      />
    </div>
  );
};

export default Hakkimda;

